import { getPitchAction } from "@/data/conversion/actions/getPitchAction";
import { Cover, SelectedFile } from "@/types/types";
import { isSelectedFile } from "@/utils/selectedFileCover/is/isSelectedFile";
import { stringifyDatesSelectedFileCover } from "@/utils/serverClientSerialization/stringifyDatesSelectedFileCover";

export const pitchGetter =
  (selectedFileCover: SelectedFile | Cover) => async (): Promise<number[]> => {
    // Callers outside the type system can still hand over nothing; that rejects instead of calling the backend.
    if (selectedFileCover === null || selectedFileCover === undefined) {
      throw new Error("No selected file");
    }

    const { pitches } =
      isSelectedFile(selectedFileCover) ?
        await getPitchAction({
          selectedFileCover: stringifyDatesSelectedFileCover(selectedFileCover),
        })
      : await getPitchAction({ selectedFileCover: selectedFileCover });
    return pitches;
  };
